import { initializeApp } from "firebase/app";
import type { Messaging } from "firebase/messaging";

// Your Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyBxfi72uCXUC6ciANzvoj3KV-uvU841agg",
  authDomain: "encrypted-erp.firebaseapp.com",
  projectId: "encrypted-erp",
  storageBucket: "encrypted-erp.firebasestorage.app",
  messagingSenderId: "1071547714324",
  appId: "1:1071547714324:web:fd0d17f141dd9866841001",
  measurementId: "G-CL7FP518B1"
};

// Initialize Firebase (SSR safe)
export const app = initializeApp(firebaseConfig);

// ---------------------------------------------------------
// Messaging must be initialized only on the client
// ---------------------------------------------------------

let messaging: Messaging | null = null;

if (typeof window !== "undefined") {
  import("firebase/messaging").then(async ({ getMessaging, isSupported }) => {
    const supported = await isSupported();

    if (!supported) {
      console.warn(
        "Firebase Messaging is not supported in this browser."
      );
      return;
    }

    messaging = getMessaging(app);
  });
}

export { messaging };
